import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
import { urlPath } from 'src/utils/lpPath'
import { smoothScroll } from 'src/utils/smoothScroll'

import LpNav from '../lpPage/LpNav'
import InterviewHead from './InterviewHead'

type InterviewPageContainerProps = {
  company: string
  interviewer: string
  baseImageUrl: string
  ogUrl: string
  children: React.ReactNode
}

const InterviewPageContainer: React.FC<InterviewPageContainerProps> = ({
  company,
  interviewer,
  ogUrl,
  children,
}) => {
  const getSmoothScroll = React.useCallback(smoothScroll, [smoothScroll])
  return (
    <>
      <InterviewHead company={company} interviewer={interviewer} ogUrl={ogUrl} />
      <main>
        <div className="newLP">
          <LpNav toScroll={getSmoothScroll} isShowSubMenu={false} />
          {children}
          <div className="contact">
            <p className="text-2xl mb-8">
              導入のご検討・相談は
              <br className="pc:hidden" />
              こちらから
            </p>
            <Link href={urlPath.contact}>
              <a>
                <button>
                  <Image
                    className="mr-4 align-baseline"
                    src="/svg/mail_icon.svg"
                    alt="お問い合わせ"
                    width={30}
                    height={30}
                    layout="raw"
                  />
                  お問い合わせ
                </button>
              </a>
            </Link>
          </div>
        </div>
      </main>
    </>
  )
}

export default InterviewPageContainer
